// extracted by mini-css-extract-plugin
export default {"nameinput_wrap":"SignNameInput_nameinput_wrap__3znkn","animate-rotate":"SignNameInput_animate-rotate__VLjkn"};